var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('mc-waste',{attrs:{"mealCounts":_vm.vm},on:{"update:mealCounts":function($event){_vm.vm=$event},"update:meal-counts":function($event){_vm.vm=$event},"input-changed":_vm.inputChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }